export let SystemThemeEnum = /*#__PURE__*/function (SystemThemeEnum) {
  SystemThemeEnum["Light"] = "light";
  SystemThemeEnum["Dark"] = "dark";
  SystemThemeEnum["Unset"] = "";
  return SystemThemeEnum;
}({});